export default function DoubleDownArrow({ count = 1 }) {
  return (
    <div className="icon-container">
      {new Array(count).fill("").map((_, i) => (
        <svg
          key={i}
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          height="32"
          viewBox="0 0 52 32"
          fill="none"
        >
          <path
            d="M15.9998 21L15.9998 11M20.1665 16.8333L15.9998 21L20.1665 16.8333ZM15.9998 21L11.8332 16.8333L15.9998 21Z"
            stroke="#FF0000"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M35.9998 21L35.9998 11M40.1665 16.8333L35.9998 21L40.1665 16.8333ZM35.9998 21L31.8332 16.8333L35.9998 21Z"
            stroke="#FF0000"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect
            x="0.75"
            y="0.75"
            width="50.5"
            height="30.5"
            rx="7.25"
            stroke="#0059B1"
            stroke-width="1.5"
          />
        </svg>
      ))}
    </div>
  );
}
